import React from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Search } from "lucide-react";

/**
 * Buscador reutilizable multi-criterio (cliente-side) para listados.
 *
 * Props:
 *   value         — texto actual
 *   onChange      — fn(v)
 *   criteria      — objeto { key: bool }
 *   onCriteriaChange — fn(c)
 *   options       — [{ key, label }]
 *   placeholder   — placeholder del input
 *   testidPrefix  — prefijo para data-testid
 *   totalLabel    — string opcional con el conteo "N de M"
 */
export default function DocSearchBar({
  value,
  onChange,
  criteria,
  onCriteriaChange,
  options,
  placeholder = "Buscar…",
  testidPrefix = "docsearch",
  totalLabel,
}) {
  return (
    <div className="bg-card border border-border rounded-md mb-3">
      <div className="flex items-center gap-2 px-3 py-2">
        <Search className="w-4 h-4 text-muted-foreground" />
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="border-0 focus-visible:ring-0 h-9"
          data-testid={`${testidPrefix}-input`}
        />
        {totalLabel && (
          <span className="text-xs text-muted-foreground whitespace-nowrap data-cell">
            {totalLabel}
          </span>
        )}
      </div>
      <div className="px-3 py-2 border-t border-border flex flex-wrap items-center gap-4 bg-muted/30">
        <span className="overline text-[10px]">Buscar por:</span>
        {options.map((opt) => (
          <label key={opt.key} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox
              checked={!!criteria[opt.key]}
              onCheckedChange={(v) => onCriteriaChange({ ...criteria, [opt.key]: !!v })}
              data-testid={`${testidPrefix}-cb-${opt.key}`}
            />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
}
